  export const TermsAndConditions = `TERMS OF USE 
Effective Date:  
Welcome to the Geneinsure Multiple Agent (Private) Limited website (“Website”). 
These Terms of Use (“Terms”) govern your access to, and use of the Website and the 
services provided through it. By accessing or using our Website, you agree to be 
bound by these Terms. If you do not agree, please do not use our Website. 
1. USE OF WEBSITE 
You agree to use this Website only for lawful purposes and in accordance with these 
Terms. You may not use the Website: - In any way that violates applicable laws or regulations - To exploit, harm, or attempt to harm others - To transmit or procure the sending of any unsolicited advertising or promotional 
materials -  To interfere with or disrupt the integrity or performance of the Website or the 
data contained therein 
We reserve the right to restrict or terminate your access if we determine you have 
violated these Terms. 
2. INTELLECTUAL PROPERTY AND COPYRIGHT 
All content on this Website, including but not limited to text, graphics, images, logos, 
branding elements, icons, data, software, documentation, designs, processes, 
workflows, business models, pricing information, service descriptions, and other 
materials (“Content”), is the exclusive property of Geneinsure Multiple Agent 
(Private) Limited or its licensors and is protected by copyright, trademark, trade 
secret, and other applicable intellectual property laws. 
You are granted a limited, non-exclusive, non-transferable license to access and 
use the Website for its intended purpose, subject to these Terms. You may not: - Copy, reproduce, modify, adapt, publish, translate, create derivative works 
from, distribute, transmit, display, perform, or sell any Content without prior 
written permission - Use the Content or any portion of it for any commercial purpose other than as 
expressly permitted 
- Remove, alter, or obscure any copyright, trademark, or other proprietary notices 
Any unauthorized use of the Content may result in civil or criminal liability and will be 
prosecuted to the fullest extent permitted by law. 
3. USER SUBMISSIONS 
By submitting any information, feedback, or content to the Website, you grant 
Geneinsure Multiple Agent (Private) Limited a worldwide, non-exclusive, royalty-free 
license to use, reproduce, modify, adapt, publish, translate, distribute, and display 
such submissions for the purpose of providing and improving our services. 
You are solely responsible for any content you submit and must ensure it does not 
infringe on the rights of any third party. 
4. DISCLAIMER OF WARRANTIES 
The Website and all Content are provided “as is” and “as available” without warranties 
of any kind, express or implied. Geneinsure Multiple Agent (Private) Limited does not 
warrant that the Website will be error-free, secure, uninterrupted, or free of viruses or 
other harmful components. 
We disclaim all warranties, including but not limited to warranties of merchantability, 
fitness for a particular purpose, non-infringement, and accuracy of information. 
5. LIMITATION OF LIABILITY 
To the maximum extent permitted by law, Geneinsure Multiple Agent (Private) Limited 
and its directors, employees, agents, or affiliates shall not be liable for any indirect, 
incidental, special, consequential, or punitive damages arising out of or related to your 
use of or inability to use the Website, even if we were advised of the possibility of such 
damages. 
Your sole and exclusive remedy for dissatisfaction with the Website is to stop using it. 
6. LINKS TO THIRD-PARTY SITES 
Our Website may contain links to third-party websites or services that are not owned 
or controlled by Geneinsure Multiple Agent (Private) Limited. We are not responsible 
for the content, privacy policies, or practices of any third-party websites. You access 
third-party sites at your own risk. 
7. CHANGES TO TERMS 
We may update these Terms from time to time to reflect changes in our services, 
applicable laws, or for other reasons. We will post the updated Terms on this page with 
the revised effective date. Your continued use of the Website after such changes 
constitutes your acceptance of the new Terms. 
8. GOVERNING LAW 
These Terms shall be governed by and construed in accordance with the laws of 
Zimbabwe, without regard to its conflict of laws principles. Any disputes arising under 
or in connection with these Terms shall be subject to the exclusive jurisdiction of the 
courts of Zimbabwe. 
9. CONTACT INFORMATION 
If you have any questions about these Terms or wish to request permissions regarding 
use of our Content, please contact us at: 
GENEINSURE MULTIPLE AGENT (PRIVATE) LIMITED 
Email: [Insert Contact Email] 
Phone: [Insert Contact Number] 
Address: [Insert Physical Address, if applicable]`

export  const privacyPolicy = `PRIVACY POLICY 
Effective Date:  
Geneinsure Multiple Agent (Private) Limited (“Geneinsure”, “we”, “us”, or “our”) is 
committed to protecting the privacy and personal data of its users in compliance with 
the Cyber and Data Protection Act of Zimbabwe (Act 5 of 2021), the Cyber and 
Data Protection (Licensing of Data Controllers and Appointment of Data 
Protection Officers) Regulations (SI 155 of 2024) and any other applicable laws and 
regulations. This Privacy Policy describes how we collect, use, disclose, and protect 
your personal information when you use our online platform and services. 
Please read this Privacy Policy carefully. By accessing or using our website or 
services, you agree to the terms of this Privacy Policy. 
1. COLLECTION OF PERSONAL DATA 
We collect personal information in the following ways: 
a.  Information You Provide Voluntarily 
When you register and use our platform, you may provide us with certain information 
voluntarily, including but not limited to: - Names - Contact information (such as your email address, phone number, residential 
address, business address/postal information) - Identification documents (company registration information, passport 
numbers/ID Number) - Insurance-related information (e.g., policy details, claims information) - Payment details (credit/debit card details, account numbers). This information 
is not stored and is securely transmitted to our payment service provider.  - Any other information you choose to provide in communications with us or 
through forms on our website 
b. Information Collected Automatically 
When you visit our website or use our services, we automatically collect certain user 
generated information related to the use of our platform. This information is not related 
to your personal data and as such does not reveal your specific identity. This 
information includes but is not limited to: 
- IP address - Browser type and version - Device type and operating system - Pages you visit and time spent on them - Referring/exit pages - Date and time of access - Usage data and analytics - Services used on the site - General geographical location from which you are using the mobile application - Information collected through cookies and other similar technologies such as 
web beacons, local storage and device fingerprinting which are used to track 
user activity and personalise user browsing experiences.  
This information provides insight into your preferences and allows us to analyse 
usage trends in order to provide a user-tailored experience. Collecting this data 
allows us to make informed decisions and improvements to our service delivery, 
catering to our clients individual needs.  
c. Information Collected Through Cookies and Tracking Technologies 
We use cookies and similar technologies to collect and store certain information. 
Cookies are small data files placed on your device to help us improve our website, 
remember your preferences, and analyse site usage. 
You may control or disable cookies through your browser settings but note that certain 
features of our website may not function properly without them. 
2. LEGAL BASIS FOR PROCESSING (IF APPLICABLE) 
Where required under applicable law (e.g., GDPR), we rely on the following legal 
bases: - - - - 
Consent (e.g., for marketing or data sharing) 
Performance of a contract (e.g., processing your requests) 
Legal obligations (e.g., recordkeeping, KYC requirements) 
Legitimate interests (e.g., to improve services, prevent fraud) 
3. HOW PERSONAL INFORMATION IS USED 
The personal data collected is used for the following broad purposes:  - To provide, maintain, and improve our online platform and services - To facilitate insurance transactions between brokers, insurers, and clients 
- To verify your identity and manage your account - To communicate with you about our services, including updates and 
notifications - To respond to your inquiries, requests, or feedback - To send you targeted marketing or promotional communications (where 
permitted by law and subject to your consent) - To analyse website usage and improve user experience -  To comply with legal, regulatory, or contractual obligations - To analyse and aggregate user data to create statistical reports. 
4. INTERNATIONAL DATA TRANSFERS 
If we transfer your data outside of your country (e.g., for hosting or technical support), 
we ensure such transfers are made in accordance with applicable data protection laws 
and that appropriate safeguards (e.g., contractual clauses) are in place. 
5. AUTOMATED PROCESSING AND PROFILING 
We may use automated systems to assist with tasks such as risk assessment, claims 
scoring, or fraud detection. Where such processing significantly affects you, you may 
request a human review of the decision, as permitted by law. 
6. THIRD-PARTY LINKS 
Our website may contain links to third-party websites. We are not responsible for their 
content or privacy practices. We recommend reviewing the privacy policies of any 
third-party site you visit. 
7. DATA RETENTION AND SECURITY 
We retain personal information only as long as necessary to fulfill the purposes for 
which it was collected or as required by law. 
We implement appropriate technical and organizational measures to protect your 
personal information against unauthorized access, disclosure, alteration, or 
destruction. However, no method of transmission over the internet or electronic 
storage is completely secure, and as such we cannot guarantee absolute security. We 
encourage all users to safeguard sensitive information such as passwords and other 
login information to reduce the risk of exposure and unauthorised access. Users are 
also urged to contact us immediately should there be suspicion of unauthorised use 
or access to their account.  
8. SENSITIVE DATA  
Geneinsure recognizes that certain personal information processed through our 
platform may be considered sensitive data, including but not limited to identification 
documents, financial information, or other details relevant to insurance coverage, and 
other information required for underwriting, claims, or compliance purposes. 
We handle sensitive data with heightened care and implement appropriate technical 
and organizational measures to ensure its security and confidentiality. These 
measures may include encryption, access controls, secure data storage, and staff 
training on data protection. 
We will only collect, use, and disclose sensitive data for specific, explicit, and legitimate 
purposes, such as: - - - - 
Providing insurance services and facilitating transactions between brokers, 
insurers, and clients 
Complying with applicable legal, regulatory, or contractual obligations 
Verifying identity and preventing fraud 
Responding to user inquiries or processing claims 
We will seek your explicit consent where required by law before processing sensitive 
data, and we will limit access to such data to those employees, partners, and service 
providers who need it to perform their duties, subject to strict confidentiality obligations. 
If you have questions about how your sensitive data is handled, or if you wish to 
exercise any applicable rights regarding that data, please contact us using the 
information provided in the Contact Information section of this policy. 
9. DISCLOSURE OF PERSONAL INFORMATION 
We may share your personal information with: - - - - 
Insurance brokers, insurers, and other partners as necessary to deliver our 
services 
Service providers and contractors who perform services on our behalf (subject 
to confidentiality obligations) 
Legal or regulatory authorities if required by law, court order, or to protect our 
rights, property, or safety, or that of our users or others 
Other parties in connection with a merger, acquisition, or sale of all or part of 
our business (you will be notified if such a transfer occurs). 
We do not sell your personal information to third parties. 
10. MINORS’ PRIVACY 
Our website and services are not directed to persons under the age of 18. We do not 
knowingly collect personal information from minors. If we learn that we have collected 
personal information from a minor without appropriate consent, we will take steps to 
delete that information promptly. 
11. PRIVACY RIGHTS OF USERS 
You may have the following rights regarding the use of your personal data: 
a. Withdraw consent: You may withdraw your consent to our processing of your 
personal information at any time, where processing is based on consent. 
Withdrawing consent will not affect the lawfulness of processing that occurred 
prior to withdrawal. You may withdraw your consent by contacting us using the 
details provided in this policy, adjusting your account settings (if available), or 
following the instructions in any promotional communications you receive. Upon 
receiving your withdrawal request, we will stop processing your personal 
information for the purposes for which consent was given, unless we have 
another lawful basis to continue such processing or are required to retain 
certain information by law or for legitimate business purposes. 
b. Access and review: You have the right to request access to the personal 
information we hold about you. Upon receiving a verified request, we will 
provide you with a copy of your personal data, along with information about how 
it is being used, disclosed, and retained, subject to any legal or contractual 
restrictions. This allows you to review the accuracy and completeness of your 
information. To request access, please contact us using the details provided in 
this policy. We may require you to verify your identity before fulfilling such 
requests to protect your privacy and security.  
c. Correction: You have the right to request that we correct or update any 
personal information we hold about you that is inaccurate, incomplete, or 
outdated. Upon receiving a verified request, we will take reasonable steps to 
ensure that your information is accurate and up to date, subject to any legal or 
contractual limitations. To request a correction or update, please contact us 
using the details provided in this policy. We may ask for additional information 
to confirm the accuracy of the changes and to verify your identity before making 
any amendments. 
d. Deletion: You have the right to request the deletion of your personal information 
that we hold, subject to certain legal or contractual obligations that may require 
us to retain it. Upon receiving a verified deletion request, we will take 
reasonable steps to remove or anonymize your personal data from our 
systems. However, please note that we may be required to retain certain 
information for compliance with legal obligations, dispute resolution, fraud 
prevention, or enforcement of our agreements. To request deletion of your 
personal information, please contact us using the details provided in this policy. 
We may require you to verify your identity before processing your request. 
e. Opt-out of promotional communication or marketing: You have the right to 
opt-out of receiving marketing or promotional communications from us at any 
time. You can exercise this right by following the unsubscribe instructions 
included in our emails or by contacting us directly using the details provided in 
this policy. Even if you opt out of marketing communications, we may still send 
you non-promotional messages related to your account or transactions, such 
as service notifications, administrative updates, or important security alerts. 
To exercise these rights, please contact us using the details provided below. 
12. CHANGES TO THIS PRIVACY POLICY 
We may update this Privacy Policy from time to time to reflect changes in our practices 
or legal requirements. We will post the revised policy on our website with an updated 
effective date. Your continued use of our website or services after changes are posted 
constitutes your acceptance of those changes. 
13. CONTACT INFORMATION 
If you have any questions, concerns, or requests regarding this Privacy Policy or your 
personal information, please contact us at: 
GENEINSURE MULTIPLE AGENT (PRIVATE) LIMITED 
Email: [Insert Contact Email] 
Phone: [Insert Contact Number] 
Address: [Insert Physical Address, if desired]`